// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-emoji {
    height: 30px;
    display: flex;
    justify-content: flex-start;
    padding-top: 5px;
    border-top: 1px solid #dfdfdf;
}




.ql-container {
    min-height: 155px;
    max-height: 160px;
}

.ql-textarea {
    /* width: 100%; */
    /* width: calc(); */
    height: 100%;
    resize: none !important;
    border: 0;
}

.ql-send {
    display: flex;
    justify-content: flex-end;
    height: 33px;
}

.ql-button {
    border-radius: 50px;
    margin-right: 10px;
    margin-bottom: 5px;
}


.ql-textarea:where(.css-dev-only-do-not-override-vryruh).ant-input-outlined:focus, :where(.css-dev-only-do-not-override-vryruh).ant-input-outlined:focus-within{
    border-color: #fff;
    box-shadow: none;
}
.ql-textarea:where(.css-dev-only-do-not-override-qnu6hi).ant-input-outlined:hover{
    border-color: #fff;
}
.ql-textarea:where(.css-dev-only-do-not-override-qnu6hi).ant-input-outlined:hover{
    border-color: #fff;
}
.ql-textarea:where(.css-dev-only-do-not-override-qnu6hi).ant-input-outlined{
    border-color: #fff;
}

/* 为TextArea设置一个class名为custom-textarea */
.custom-textarea .ant-input-outlined {
    overflow-y: scroll;
    /* 如果需要，可以设置为auto来根据内容显示滚动条 */
}

/* 自定义滚动条的样式 */
.custom-textarea .ant-input-outlined::-webkit-scrollbar {
    width: 12px;
    /* 设置滚动条的宽度 */
}

/* 自定义滚动条滑块的样式 */
.custom-textarea .ant-input-outlined::-webkit-scrollbar-thumb {
    background-color: #1d90ff;
    /* 设置滚动条滑块的颜色 */
    border-radius: 6px;
    /* 设置滚动条滑块的圆角 */
}

/* 自定义滚动条轨道的样式 */
.custom-textarea .ant-input-outlined::-webkit-scrollbar-track {
    background-color: #f0f0f0;
    /* 设置滚动条轨道的颜色 */
}

/* 兼容Firefox */
.custom-textarea .ant-input-outlined {
    scrollbar-width: thin;
    /* "auto" or "thin" */
    scrollbar-color: #1d90ff #f0f0f0;
    /* 滚动条滑块颜色 滚动条轨道颜色 */
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/PersonMessage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,6BAA6B;AACjC;;;;;AAKA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,cAAc;AACd;IACI,WAAW;IACX,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gCAAgC;IAChC,oBAAoB;AACxB","sourcesContent":[".ql-emoji {\r\n    height: 30px;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    padding-top: 5px;\r\n    border-top: 1px solid #dfdfdf;\r\n}\r\n\r\n\r\n\r\n\r\n.ql-container {\r\n    min-height: 155px;\r\n    max-height: 160px;\r\n}\r\n\r\n.ql-textarea {\r\n    /* width: 100%; */\r\n    /* width: calc(); */\r\n    height: 100%;\r\n    resize: none !important;\r\n    border: 0;\r\n}\r\n\r\n.ql-send {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    height: 33px;\r\n}\r\n\r\n.ql-button {\r\n    border-radius: 50px;\r\n    margin-right: 10px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n\r\n.ql-textarea:where(.css-dev-only-do-not-override-vryruh).ant-input-outlined:focus, :where(.css-dev-only-do-not-override-vryruh).ant-input-outlined:focus-within{\r\n    border-color: #fff;\r\n    box-shadow: none;\r\n}\r\n.ql-textarea:where(.css-dev-only-do-not-override-qnu6hi).ant-input-outlined:hover{\r\n    border-color: #fff;\r\n}\r\n.ql-textarea:where(.css-dev-only-do-not-override-qnu6hi).ant-input-outlined:hover{\r\n    border-color: #fff;\r\n}\r\n.ql-textarea:where(.css-dev-only-do-not-override-qnu6hi).ant-input-outlined{\r\n    border-color: #fff;\r\n}\r\n\r\n/* 为TextArea设置一个class名为custom-textarea */\r\n.custom-textarea .ant-input-outlined {\r\n    overflow-y: scroll;\r\n    /* 如果需要，可以设置为auto来根据内容显示滚动条 */\r\n}\r\n\r\n/* 自定义滚动条的样式 */\r\n.custom-textarea .ant-input-outlined::-webkit-scrollbar {\r\n    width: 12px;\r\n    /* 设置滚动条的宽度 */\r\n}\r\n\r\n/* 自定义滚动条滑块的样式 */\r\n.custom-textarea .ant-input-outlined::-webkit-scrollbar-thumb {\r\n    background-color: #1d90ff;\r\n    /* 设置滚动条滑块的颜色 */\r\n    border-radius: 6px;\r\n    /* 设置滚动条滑块的圆角 */\r\n}\r\n\r\n/* 自定义滚动条轨道的样式 */\r\n.custom-textarea .ant-input-outlined::-webkit-scrollbar-track {\r\n    background-color: #f0f0f0;\r\n    /* 设置滚动条轨道的颜色 */\r\n}\r\n\r\n/* 兼容Firefox */\r\n.custom-textarea .ant-input-outlined {\r\n    scrollbar-width: thin;\r\n    /* \"auto\" or \"thin\" */\r\n    scrollbar-color: #1d90ff #f0f0f0;\r\n    /* 滚动条滑块颜色 滚动条轨道颜色 */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
